<div class="event-form">
  <event-participation
    [model]="event"
    [profile]="profile"
    [loading]="sendingParticipation"
    [participated]="participationSent"
    (participate)="doParticipate($event)"
    (closeForm)="doClose()"
  ></event-participation>
</div>
